import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    jwt: null,
    access_token: null,
    displayName: null,
    uid: null,
    user: null,
    email: null,
    group: null,
    domain: null,
    expirationTime: null,
    scope: null,
    role: null,
    defaultCrm: null,
    analyticsProcessingEnabled: false,
    callAssistantEnabled: false,
    chatAssistantEnabled: false,
    userPreferences: {},
};
export const userCredentialSlice = createSlice({
    name: 'userCredential',
    initialState,
    reducers: {
        setUserCredentials: (state, action) => {
            return { ...action.payload };

        },
        updateUserCredential: (state, action) => {
            return { ...state, ...action.payload };

        },
        clearUserCredentials: (state) => {
            return { ...initialState };

        },
    },
});

export const { setUserCredentials, updateUserCredential, clearUserCredentials } = userCredentialSlice.actions;

// Selectors
export const selectUserCredentials = (state) => state.userCredential;
export default userCredentialSlice.reducer;